import { AlertTriangle } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Alert, AlertTitle } from "@/components/ui/alert";
import type { Vehicle } from "@/types";

interface Props {
  vehicles: Vehicle[];
  selected: number[];
  onToggle: (vehicleId: number) => void;
}

export const VehiclePicker = ({ vehicles, selected, onToggle }: Props) => (
  <div className="mb-6">
    <Label className="block mb-3 text-lg font-medium">
      Seleccione los vehículos
    </Label>
    {vehicles.length === 0 ? (
      <Alert>
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Cargando vehículos...</AlertTitle>
        <p className="text-sm">
          Obteniendo la lista de vehículos disponibles.
        </p>
      </Alert>
    ) : (
      <div className="grid grid-cols-1 gap-2">
        {vehicles
          .filter(
            (vehicle) =>
              !vehicle.status || vehicle.status === "ACTIVO"
          )
          .map((vehicle) => (
            <label
              key={vehicle.id}
              className={`border-2 rounded-lg p-3 transition-colors cursor-pointer block ${
                selected.includes(vehicle.id)
                  ? "border-primary bg-primary-soft"
                  : "border-gray-200 hover:border-gray-300"
              }`}
            >
              <div className="flex items-center space-x-3">
                <Checkbox
                  checked={selected.includes(vehicle.id)}
                  onCheckedChange={() => onToggle(vehicle.id)}
                  className="h-4 w-4"
                />
                <div className="flex-1">
                  <div className="font-medium">{vehicle.plate}</div>
                  <div className="text-sm text-gray-600">
                    {vehicle.brand} {vehicle.model}
                    {vehicle.unitType &&
                      ` - ${vehicle.unitType.name}`}
                  </div>
                </div>
              </div>
            </label>
          ))}
      </div>
    )}
  </div>
);
